import { useState } from "react";
import ApiService from "../../services/ApiServiceClass";

export type CategoryType = {
    id: number,
    category_type: string,
    category_type_id: number,
    name: string
}

export type TransformedCategoryType = {
    id: string,
    category_type_id: string,
    value: string
}

export const useCategoryForRadio = () => {
    const [categoriesForRadio, setCategoriesForRadio] = useState<TransformedCategoryType[]>([]);

    const fetchCategories = async () => {

        try {
            const responseData = await ApiService.getCategories();
            let transforedData = [];
            if (responseData.data) {
                transforedData = responseData.data.map((item: CategoryType) => ({
                    id: item.id,
                    category_type_id: item.category_type_id,
                    value: item.name
                }));                
            }
            setCategoriesForRadio(transforedData);
            return transforedData;
        } catch (error) {
            throw(error);
        }
    }

    return { categoriesForRadio, setCategoriesForRadio,  fetchCategories};
}